/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CriteriaForLocationResponse
 */
export interface CriteriaForLocationResponse {
    /**
     * 
     * @type {string}
     * @memberof CriteriaForLocationResponse
     */
    stationCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CriteriaForLocationResponse
     */
    cityCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CriteriaForLocationResponse
     */
    regionCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CriteriaForLocationResponse
     */
    countryCode?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CriteriaForLocationResponse
     */
    isOutboundArrival?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CriteriaForLocationResponse
     */
    isOutboundDeparture?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CriteriaForLocationResponse
     */
    exclude?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CriteriaForLocationResponse
     */
    isInboundArrival?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CriteriaForLocationResponse
     */
    isInboundDeparture?: boolean;
}

export function CriteriaForLocationResponseFromJSON(json: any): CriteriaForLocationResponse {
    return CriteriaForLocationResponseFromJSONTyped(json, false);
}

export function CriteriaForLocationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CriteriaForLocationResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'stationCode': !exists(json, 'stationCode') ? undefined : json['stationCode'],
        'cityCode': !exists(json, 'cityCode') ? undefined : json['cityCode'],
        'regionCode': !exists(json, 'regionCode') ? undefined : json['regionCode'],
        'countryCode': !exists(json, 'countryCode') ? undefined : json['countryCode'],
        'isOutboundArrival': !exists(json, 'isOutboundArrival') ? undefined : json['isOutboundArrival'],
        'isOutboundDeparture': !exists(json, 'isOutboundDeparture') ? undefined : json['isOutboundDeparture'],
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
        'isInboundArrival': !exists(json, 'isInboundArrival') ? undefined : json['isInboundArrival'],
        'isInboundDeparture': !exists(json, 'isInboundDeparture') ? undefined : json['isInboundDeparture'],
    };
}

export function CriteriaForLocationResponseToJSON(value?: CriteriaForLocationResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'stationCode': value.stationCode,
        'cityCode': value.cityCode,
        'regionCode': value.regionCode,
        'countryCode': value.countryCode,
        'isOutboundArrival': value.isOutboundArrival,
        'isOutboundDeparture': value.isOutboundDeparture,
        'exclude': value.exclude,
        'isInboundArrival': value.isInboundArrival,
        'isInboundDeparture': value.isInboundDeparture,
    };
}


